import shadows from '../../assets/shadows.json';

const getBoxShadow = (i) => {
  return shadows[i % 12].shadow;
};

export default getBoxShadow;
